import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import PortfolioImage from "@/components/PortfolioImage";

const CATEGORIES = ["Tous", "Installation neuve", "Rénovation", "Éclairage", "Bornes de recharge", "Diagnostic"];

export default function RealisationsPage() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("Tous");

  useEffect(() => {
    api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = cat === "Tous" ? items : items.filter((i) => i.category === cat);

  return (
    <div className="pt-32 pb-24 bg-background" data-testid="realisations-page">
      <section className="container-page">
        <div className="grid md:grid-cols-12 gap-6 mb-14">
          <div className="md:col-span-7">
            <div className="overline copper mb-4">Réalisations · {items.length} chantiers</div>
            <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              Le travail<br/>parle de lui-même.
            </h1>
          </div>
          <div className="md:col-span-5 md:pt-4">
            <p className="text-muted-foreground leading-relaxed">
              Une sélection de chantiers livrés ces dernières années pour des particuliers, des architectes,
              des copropriétés et des commerces.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-10 border-y border-border py-4">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`filter-${c}`}
              className={`overline px-4 py-2 border transition-colors ${
                cat === c ? "bg-graphite text-white border-graphite" : "border-border hover:border-foreground"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((p) => (
            <article key={p.id} className="bg-card border border-border group" data-testid={`realisation-${p.id}`}>
              <div className="img-hover aspect-[4/3] bg-muted relative">
                <PortfolioImage item={p} />
                <div className="absolute top-3 left-3 bg-graphite text-white px-3 py-1 overline z-10">
                  {p.category}
                </div>
              </div>
              <div className="p-6">
                <div className="font-mono text-xs text-muted-foreground mb-2">{p.location}{p.year ? ` · ${p.year}` : ""}</div>
                <h3 className="font-display font-bold text-xl tracking-tight leading-tight">{p.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{p.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-20 border-t border-border pt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
              Un projet similaire ?
            </h3>
            <p className="text-muted-foreground mt-2">Décrivez-le, nous chiffrons sous 48h.</p>
          </div>
          <Link to="/#contact" className="btn-copper" data-testid="cta-contact">
            Demander un devis
            <ArrowUpRight size={18} strokeWidth={2.5} />
          </Link>
        </div>
      </section>
    </div>
  );
}
